import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    16: [
        'M5.686 10.314L1.695 9.226C.275 8.839.14 7.312 1.45 6.657L13.656.554c1.352-.676 2.468.434 1.79 1.79L9.343 14.55c-.653 1.306-2.18 1.179-2.569-.245l-1.088-3.99zm-1.898-2.59l3.526.962.962 3.526 4.488-8.976-8.976 4.488z',
    ],
};
const IconLocation = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconLocation.displayName = 'IconLocation';

export { IconLocation };
//# sourceMappingURL=IconLocation.js.map
